import {listBacSy2, listGender} from "data/list";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
const {INPUT, SELECT, DATE, COMBO_BOX, AUTO_COMPLETE} = FIELD_TYPE;

import {DataFormField} from "types/models/input-field-type";

const fields: DataFormField[] = [
  {
    type: DATE,
    label: "Ngày tạo",
    name: "ngayTao",
    optionsTime: {showTime: true, format: FORMAT_TIME.dateTime},
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "dienThoai",
    disable: true,
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "diaChiTongHop",
    disable: true,
  },

  {
    type: SELECT,
    label: "Loại KCB",
    name: "loaiKCB",
    options: JSON.parse(localStorage.getItem("loaiKCB")) || [],
    placeholder: "Không có",
  },

  {
    type: INPUT,
    label: "Thân nhân",
    name: "thanNhan",
    disable: true,
  },
  {
    type: AUTO_COMPLETE,
    label: "Người thực hiện",
    name: "tenDieuDuong",
    options: listBacSy2,
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái ĐDNT",
    name: "trangThai",
    options: JSON.parse(localStorage.getItem("TTPhieu")) || [],
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Tra thuốc",
    name: "traThuoc",
    disable: true,
    options: JSON.parse(localStorage.getItem("TTTraThuoc")) || [],
  },
  {
    type: COMBO_BOX,
    label: "Phòng",
    name: "phong",
    rules: [{required: true, message: "Bạn chưa chọn phòng"}],
    options: JSON.parse(localStorage.getItem("phongKhamNoPeople")) || [],
    allowClear: false,
  },
  {
    type: INPUT,
    label: "Lý do khám",
    css: {
      lg: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 10, md: 8, lg: 2},
    wrapperCol: {xs: 14, md: 16, lg: 22},
    name: "lyDoKham",
  },
];

export default fields;
